import { render, staticRenderFns } from "./HistoryOrders.vue?vue&type=template&id=3ab95db9&scoped=true"
import script from "./HistoryOrders.vue?vue&type=script&lang=js"
export * from "./HistoryOrders.vue?vue&type=script&lang=js"
import style0 from "./HistoryOrders.vue?vue&type=style&index=0&id=3ab95db9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab95db9",
  null
  
)

export default component.exports